<template>
  <el-form
    label-position="right"
    label-width="200px"
    ref="ruleForm"
    :model="parentInstance.inquireRuleDTO"
    :rules="rules"
  >
    <div style="color: #F56C6C;font-size: 14px;padding-bottom: 10px;padding-left: 100px;">
      <div>1.邀请函发布后，供应商需在报价截止时间前通过邮件内的链接完成在线报价，截止时间前可撤回并重新报价。</div>
      <div>2.邀请函发布后，不可在报价截止时间前，提前结束报价。</div>
      <div>3.报价截止时间后方可查看供应商报价内容，并进行下一步的谈判或报价评比等流程操作。</div>
    </div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="报价截止时间:" prop="endTime">
          <el-date-picker
            :disabled="readonly"
            class="w100"
            v-model="parentInstance.inquireRuleDTO.endTime"
            type="datetime"
            placeholder="选择日期"
            :picker-options="startTimePicker"
            @focus="focusFun"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12" style="height:100px;">
        <el-form-item label="报价类型:" prop="quoteRule">
          <el-radio
            :disabled="
              readonly || parentInstance.projectRuleDTO.quoteRule != null
            "
            v-model="parentInstance.inquireRuleDTO.quoteRule"
            :label="1"
          >
            标准报价
            <el-tooltip
              class="item"
              effect="dark"
              content="供应商在报价截止前可撤回报价"
              placement="top-start"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </el-radio>
          <!-- <el-popover
            placement="bottom"
            width="340"
            :append-to-body="false"
            trigger="manual"
            :value="parentInstance.inquireRuleDTO.quoteRule === 2 && showFix"
            popper-class="zs-popover"
          >
            <div>
              <span>当报价家数≥ </span>
              <el-input-number
                :disabled="readonly || parentInstance.projectRuleDTO.quoteRule!= null"
                size="mini"
                v-model="parentInstance.inquireRuleDTO.quoteSize"
                controls-position="right"
                :min="1"
              ></el-input-number>
              <span> 家, 提前结束</span>
            </div>
            <el-radio
              :disabled="
                readonly || parentInstance.projectRuleDTO.quoteRule != null
              "
              slot="reference"
              v-model="parentInstance.inquireRuleDTO.quoteRule"
              :label="2"
            >
              快速询单
              <el-tooltip
                class="item"
                effect="dark"
                content="供应商一经报价不可撤回，当满足设置的报价家数后询单报价结束"
                placement="top-start"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-radio>
          </el-popover> -->
        </el-form-item>
      </el-col>
      <!-- <el-col :span="12">
        <el-form-item label="价格开启限制" prop="openPrice">
          <el-radio
            :disabled="
              readonly || parentInstance.projectRuleDTO.openPrice != null || parentInstance.inquireRuleDTO.quoteRule == 2
            "
            v-model="parentInstance.inquireRuleDTO.openPrice"
            :label="false"
          >
            不开启
          </el-radio>
          <el-popover
            placement="bottom"
            width="415"
            :append-to-body="false"
            trigger="manual"
            :value="parentInstance.inquireRuleDTO.openPrice && showFix"
            popper-class="zs-popover"
          >
            <div>
              <span>当报价家数≥ </span>
              <el-input-number
                :disabled="readonly || parentInstance.projectRuleDTO.openPrice != null"
                size="mini"
                v-model="parentInstance.inquireRuleDTO.openSize"
                controls-position="right"
                :min="1"
              ></el-input-number>
              <span> 家, 采购人才能看到供应商报价</span>
            </div>
            <el-radio
              :disabled="
                readonly || parentInstance.projectRuleDTO.openPrice != null || parentInstance.inquireRuleDTO.quoteRule == 2
              "
              slot="reference"
              v-model="parentInstance.inquireRuleDTO.openPrice"
              :label="true"
            >
              开启
            </el-radio>
          </el-popover>
        </el-form-item>
      </el-col> -->
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="币种:" prop="currency">
          <zs-select
            :api="listCurrency"
            v-model="parentInstance.inquireRuleDTO.currency"
            @labelChange="currencyLabelChange"
            style="width:140px;"
            :disabled="
              readonly || parentInstance.projectRuleDTO.currency != null
            "
          ></zs-select>
          <el-radio
            style="margin-left:20px;"
            v-model="parentInstance.inquireRuleDTO.changeCurrency"
            :label="true"
            :disabled="
              readonly || parentInstance.projectRuleDTO.changeCurrency != null
            "

          >
            允许供应商修改
          </el-radio>
          <el-radio
            v-model="parentInstance.inquireRuleDTO.changeCurrency"
            :label="false"
            :disabled="
              readonly || parentInstance.projectRuleDTO.changeCurrency != null
            "
          >
            不允许供应商修改
          </el-radio>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="要求供应商上传报价文件:" prop="uploadFile">
          <el-radio
            v-model="parentInstance.inquireRuleDTO.uploadFile"
            :label="true"
            :disabled="
              readonly || parentInstance.projectRuleDTO.uploadFile != null
            "
          >
            要求
          </el-radio>
          <el-radio
            v-model="parentInstance.inquireRuleDTO.uploadFile"
            :label="false"
            :disabled="
              readonly || parentInstance.projectRuleDTO.uploadFile != null
            "
          >
            不要求
          </el-radio>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import zsSelect from '@/components/zsSelect'
import { mapActions } from 'vuex'
export default {
  components: {
    zsSelect
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  inject: ['parentInstance'],
  data() {
    return {
      showFix: true,
      rules: {
        endTime: [{ required: true, message: '报价截止时间不能为空', trigger: 'blue' }],
        quoteRule: [{ required: true, message: '报价类型不能为空' }],
        currency: [{ required: true, message: '货币不能为空' }],
        uploadFile: [{ required: true, message: '不能为空' }]
      }
    }
  },
  computed: {
    startTimePicker() {
      return {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000
          )
        }
      }
    }
  },
  created() {
    this.showFix = false
    this.$nextTick(() => {
      this.showFix = true
      this.$refs.ruleForm.clearValidate(['endTime'])
    })
  },
  methods: {
    ...mapActions(['listCurrency']),
    currencyLabelChange(val, text) {
      this.parentInstance.inquireRuleDTO.currencyCh = text
    },
    focusFun() {
      if (!this.parentInstance.inquireRuleDTO.endTime) {
        this.$set(this.parentInstance.inquireRuleDTO, 'endTime', new Date())
      }
    }
  }
}
</script>

<style></style>
